<template>
  <page-background>
    <template v-slot>
      <auth-card
        class="loginView"
        inverted="right"
      >
        <div class="loginView__left">
          <h1 class="appContent__title">{{ $t('pageNames.' + $route.name) }}</h1>
          <p>{{ $t('auth.login.view.happy') }}</p>
          <account-confirmation />
          <el-alert
            v-if="hasAlert"
            :title="$t('auth.login.view.registered')"
            :description="$t('auth.login.view.checkYourEmails')"
            type="success"
          />
          <login-form />
        </div>
        <div class="loginView__right">
          <div>
            <p>{{ $t('auth.login.view.first') }}</p>
            <el-button @click="$router.push({ name: 'register' })">
              {{ $t('auth.login.view.registerButton') }}
            </el-button>
          </div>
        </div>
      </auth-card>
    </template>
  </page-background>
</template>

<script>
import AuthCard from '@/components/auth/AuthCard'
import LoginForm from '@/components/auth/LoginForm'
import AccountConfirmation from '@/components/auth/AccountConfirmation'

export default {
  name: "Login",
  components: {
    AuthCard,
    LoginForm,
    AccountConfirmation
  },
  computed: {
    hasAlert() {
      if (this.$route.params.registered === true) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.loginView';

#{$c} {
  @include respond-above(xs) {
    min-height: calc(100vh - 125px);
  }

  #{$c}__left,
  #{$c}__right {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
      font-size: 18px;
      @include respond-above(xs) {
        font-size: 22px;
      }
    }
  }

  #{$c}__left {
    padding: 92px 36px 20px 36px;
    @include respond-above(xs) {
      padding: 72px 72px 20px 72px;
    }
    form {
      width: 240px;
    }
  }

  #{$c}__right {
    @include respond-above(xs) {
      padding: 0 72px 72px 72px;
    }
    justify-content: center;
    height: 100%;

    div {
      border: 1px solid #e7e7e7;
      padding: 15px;
    }

    @include respond-below(md) {
      padding-bottom: 72px;
    }
  }
}
</style>